import semver from 'semver';

type TAccordionDefaultStyles = {
  headingColor: string;
  headingTextColor: string;
  borderRadius: number;
  borderColor: string;
  includeBorder: boolean;
  focusColor?: string;
};

export const accordionDefaultStyles: {
  [key: string]: TAccordionDefaultStyles;
} = {
  base: {
    headingColor: '#1A1A2B',
    headingTextColor: '#fff',
    borderRadius: 12,
    includeBorder: true,
    borderColor: '#1A1A2B',
    focusColor: '#fff',
  },
  '1.5.0': {
    headingColor: '#fff',
    headingTextColor: '#060709',
    borderRadius: 12,
    includeBorder: true,
    borderColor: '#D1D5E7',
    focusColor: '#000',
  },
};

export const getDefaultStyles = (blockMetaPackageVersion: string = '') => {
  if (!blockMetaPackageVersion || !semver.valid(blockMetaPackageVersion)) {
    return accordionDefaultStyles['base'];
  }

  if (semver.gte(blockMetaPackageVersion, '1.5.0')) {
    return accordionDefaultStyles['1.5.0'];
  }
  //

  return accordionDefaultStyles['base'];
};
